interface Props {
  percentage: number | null;
  size?: 'sm' | 'md';
}

export default function QuizScoreBadge({ percentage, size = 'sm' }: Props) {
  if (percentage == null) return null;

  const color = percentage >= 80 ? '#00A86B' : percentage >= 60 ? '#3B82F6' : percentage >= 40 ? '#F59E0B' : '#EF4444';
  const px = size === 'sm' ? '6px 10px' : '8px 14px';
  const fs = size === 'sm' ? '11px' : '13px';

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        background: `${color}22`,
        color,
        padding: px,
        borderRadius: '12px',
        fontSize: fs,
        fontWeight: 600,
        border: `1px solid ${color}44`,
      }}
    >
      {Math.round(percentage)}%
    </span>
  );
}
